/* eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const APPLICATION_STATUS = {
    NOT_TRANSFERRED:      'NOT_TRANSFERRED',
    TRANSFERRED:          'TRANSFERRED',
    WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
    REJECTED:             'REJECTED',
    WAITING_FOR_PAYMENT:  'WAITING_FOR_PAYMENT',
    ISSUED:               'ISSUED',
    PENDING:              'PENDING',
    ACCEPTED:             'ACCEPTED'
}
export default APPLICATION_STATUS